import React from "react";
import { useTranslation } from "@/langs/useTranslation";
import { BreadCrumbs } from "@/components/device/BreadCrumbs";
import useStyles from "@/styles/groupsStyle";
import InstallHistoryList from "./InstallHistoryList";

const InstallHistory = () => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <>
      <BreadCrumbs noTranslate pageName={t({ defaultMessage: "安装历史" })} />
      <div className={classes.paperWrapper}>
        <InstallHistoryList />
      </div>
    </>
  );
};

export default InstallHistory;